var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('meta',{attrs:{"name":"viewport","content":"width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"}}),_c('router-view'),(_vm.showTabbar)?_c('Tabbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }